import React from 'react';
import { inject, observer } from 'mobx-react';

import mvcLogo from 'mvc_awards/mvc-logo.svg';
import DesktopNav from './DesktopNav';
import MobileNav from './MobileNav';
import ActionMenus from './ActionMenus';
import FeaturedSponsor from './FeaturedSponsor';

@inject('headerState')
@observer
class Header extends React.PureComponent {
  render() {
    const { mvcHomePath } = this.props.headerState;

    return (
      <>
        <MobileNav />

        <header className="mvc-header mvc-blue-background">
          <a href={mvcHomePath} className="mvc-header-logo">
            <img
              src={mvcLogo}
              alt="Military and Veteran Community Choice Awards Logo"
            />
          </a>

          <DesktopNav />

          <ActionMenus />

          <FeaturedSponsor />
        </header>
      </>
    );
  }
}

export default Header;
